export default __webpack_public_path__ + "157de84955d3d0778f1bb2f4298bab0c.svg";